type ModalStateSetter = React.Dispatch<
  React.SetStateAction<{ isOpen: boolean; isVisible: boolean }>
>;

// ✅ 공통 모달 닫기 함수
export const closeModal = (setModalState: ModalStateSetter) => {
  setModalState({ isOpen: false, isVisible: false });
};
